import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  requests: [],
  packages:[],
  selectedRequest: null,
  selectedPackage: null,
  activeComponent: null,
  selectedItem: null,
};

export const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    setPackages: (state, action) => {
      state.packages = action.payload;
    },
    setRequests: (state, action) => {
      state.requests = action.payload;
    },
    setSelectedRequest: (state, action) => {
      state.selectedRequest = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setActiveComponent: (state, action) => {
      state.activeComponent = action.payload;
    },
    setActiveItem: (state, action) => {
      state.selectedItem = action.payload;
    },
  },
});

export const { setPackages, setRequests, setSelectedRequest, setSelectedPackage,setActiveComponent,setActiveItem } = commonSlice.actions;

export default commonSlice.reducer;
